import { Input, InputProps } from 'components/UI';

const ProductFieldInput = (props: InputProps) => (
  <Input
    bgColor="white"
    _focus={{
      bgColor: 'white',
    }}
    _hover={{
      bgColor: 'white',
    }}
    {...props}
  />
);

export default ProductFieldInput;
